import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Production vs Development Mode',
  content: `
Pliable offers two environments:

- **Development Mode**: A sandbox for testing changes without affecting live data.
- **Production Mode**: The live environment powering reports and downstream systems.

# Key Differences

| Feature | Development | Production |
|---------|-------------|------------|
| Data Changes | Test freely | Locked down |
| Metrics | Draft metrics available | Published metrics only |
| Schema Changes | Allowed | Requires publish |
| Builds | Development builds | Production builds |
| Access | Builders and Admins | All users |

# Switching Environments

## Development to Production

1. Make a successful Development build.
2. Click **Publish Changes** under the Develop Mode dropdown.
3. Preview what will be deployed to Production Mode and click **Confirm Publish**.

## Production to Development

Navigate to **Production Mode dropdown > Go to Development**.

# Use Cases

- **Testing**: Add experimental metrics in Develop Mode.
- **Hotfixes**: Patch Production builds without disrupting users.

# Best Practices

- Always test schema changes in **Develop Mode** first.
- Use **Environment Locking** to prevent accidental Production edits.
`,
};

export default doc;
